import { Link, useLocation, useNavigate } from "@remix-run/react";
import { ChevronLeft, Home, ChevronRight } from "lucide-react";
import styles from "./BrowserNav.module.css";

export default function BrowserNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  if (pathname === "/" || pathname.startsWith("/games/game-") || pathname.startsWith("/naomi/chat")) return null;

  return (
    <div className={styles.nav}>
      <button className={styles.btn} onClick={() => navigate(-1)} aria-label="Back">
        <ChevronLeft size={15} strokeWidth={1.4} />
      </button>
      <Link to="/" className={styles.btn} aria-label="Home">
        <Home size={15} strokeWidth={1.4} />
      </Link>
      <button className={styles.btn} onClick={() => navigate(1)} aria-label="Forward">
        <ChevronRight size={15} strokeWidth={1.4} />
      </button>
    </div>
  );
}
